export class BrixxPlan {
    planguid: string = '';
    planname: string = '';
    plancreated: Date = new Date();
    planstarted: Date = new Date();
    planlength: number = 0;
    planStartDate: Date = new Date();
    isChoosedToKeep: number = 0;
    planlengthName: string = '';
    lastOpened: Date = new Date();
    lastedited: Date = new Date();
    logolink: string = '';
    isShared: boolean = false;
    planOwner: string = '';
    rights: string = '';
    sharedUserCount: number = 0;
    planUrl: string = '';
    companyGuid: string = '';
    companyId: number = 0;
    isTeamMember: boolean = false;
    isOwnCompanyPlan = false;
    isNewPlanButton = false;
    isNeedToStartSubscription = false;
    isNeedToBuyPlanSlot = false;
    isNeedToResumeSubscription = false;
    companyName = '';
    planLowerDataText = '';
    
}
